if (!customElements.get('collections-tabs-vertical')) {
  class CollectionsTabsVertical extends HTMLElement {
    constructor() {
      super();
      this.sectionId = null;
      this.tabButtons = [];
      this.tabPanes = [];
      this.marquee = null;
      this.track = null;
    }

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      if (!this.sectionId) return;

      this.tabButtons = this.querySelectorAll('.vtab-button');
      this.tabPanes = this.querySelectorAll('.tab-pane');
      this.marquee = this.querySelector('.vtabs-marquee');
      this.track = this.querySelector('.vtabs-marquee-track');

      this.mobileScrollRAF = null;
      this.mobileScrollPaused = false;
      this.mobileResumeTimer = null;

      /* Read speed from data attribute: higher number = slower scroll */
      var speedSetting = parseInt(this.dataset.scrollSpeed, 10);
      if (isNaN(speedSetting) || speedSetting <= 0) {
        this.mobileScrollSpeed = 0.5; /* fallback default */
      } else {
        /* Map: 1 = very fast (2px), 10 = medium (0.8px), 30 = slow (0.3px) */
        this.mobileScrollSpeed = Math.max(0.2, 8 / speedSetting);
      }

      this.bindEvents();
      this.syncMarqueeHeight();
      this.initMobileAutoScroll();

      this.resizeObserver = new ResizeObserver(function () {
        this.syncMarqueeHeight();
        this.initMobileAutoScroll();
      }.bind(this));

      var content = this.querySelector('.vtabs-content');
      if (content) {
        this.resizeObserver.observe(content);
      }
    }

    disconnectedCallback() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
      if (this.mobileScrollRAF) {
        cancelAnimationFrame(this.mobileScrollRAF);
      }
      if (this.mobileResumeTimer) {
        clearTimeout(this.mobileResumeTimer);
      }
    }

    bindEvents() {
      var self = this;
      this.tabButtons.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          self.onTabClick(e);
        });
      });
    }

    onTabClick(e) {
      var targetId = e.currentTarget.dataset.id;
      if (!targetId) return;

      /* Remove active from all buttons across all duplications */
      this.tabButtons.forEach(function (btn) {
        btn.classList.remove('active');
      });

      /* Add active to all copies of the clicked tab */
      this.querySelectorAll('.vtab-button[data-id="' + targetId + '"]').forEach(function (btn) {
        btn.classList.add('active');
      });

      /* Switch tab pane */
      this.tabPanes.forEach(function (pane) {
        pane.classList.remove('active');
      });

      var targetPane = document.getElementById(targetId);
      if (targetPane) {
        targetPane.classList.add('active');
      }
    }

    syncMarqueeHeight() {
      var content = this.querySelector('.vtabs-content');
      if (content && this.marquee && window.innerWidth >= 768) {
        this.marquee.style.height = content.offsetHeight + 'px';
      } else if (this.marquee) {
        this.marquee.style.height = 'auto';
      }
    }

    initMobileAutoScroll() {
      var self = this;
      /* Cancel any existing animation */
      if (this.mobileScrollRAF) {
        cancelAnimationFrame(this.mobileScrollRAF);
        this.mobileScrollRAF = null;
      }

      if (!this.marquee || window.innerWidth >= 768) return;

      /* Calculate the scroll width of one set for looping */
      var firstSet = this.marquee.querySelector('.vtabs-set');
      if (!firstSet) return;
      this.mobileSetWidth = firstSet.offsetWidth;

      /* Start auto-scroll loop */
      function scrollStep() {
        if (!self.mobileScrollPaused && self.marquee) {
          self.marquee.scrollLeft += self.mobileScrollSpeed;
          /* Loop: when scrolled past one full set, jump back */
          if (self.marquee.scrollLeft >= self.mobileSetWidth) {
            self.marquee.scrollLeft -= self.mobileSetWidth;
          }
        }
        self.mobileScrollRAF = requestAnimationFrame(scrollStep);
      }
      this.mobileScrollRAF = requestAnimationFrame(scrollStep);

      /* Touch events: pause on touch, resume after release */
      this.marquee.addEventListener('touchstart', function () {
        self.mobileScrollPaused = true;
        if (self.mobileResumeTimer) {
          clearTimeout(self.mobileResumeTimer);
        }
      }, { passive: true });

      this.marquee.addEventListener('touchend', function () {
        if (self.mobileResumeTimer) {
          clearTimeout(self.mobileResumeTimer);
        }
        /* Resume auto-scroll 2 seconds after letting go */
        self.mobileResumeTimer = setTimeout(function () {
          /* Fix scroll position for seamless loop */
          if (self.marquee.scrollLeft >= self.mobileSetWidth) {
            self.marquee.scrollLeft = self.marquee.scrollLeft % self.mobileSetWidth;
          }
          self.mobileScrollPaused = false;
        }, 2000);
      }, { passive: true });
    }
  }

  customElements.define('collections-tabs-vertical', CollectionsTabsVertical);
}
